var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "chart-wrapper", staticStyle: { "max-width": "100%" } },
      [
        _vm.parallelEventsNaN.length
          ? _c("div", {
              domProps: { innerHTML: _vm._s(_vm.parallelEventNaNHTML()) },
            })
          : _vm._e(),
        _c("div", {
          ref: "myChart",
          staticClass: "chart",
          staticStyle: { "box-shadow": "0 1px 8px 0 rgb(0 0 0 / 16%)" },
          attrs: { option: _vm.option, "data-cy": "test" },
        }),
      ]
    ),
    _vm.isParallel && _vm.showLinks
      ? _c(
          "div",
          { staticStyle: { "margin-top": "1em" } },
          [
            _c("div", { staticClass: "history--heading" }, [
              _vm._v(" " + _vm._s(_vm.$t("info.parallelEvent")) + "s "),
            ]),
            _c(
              "pui-card",
              {
                staticStyle: { "justify-content": "center" },
                attrs: { title: "" },
              },
              _vm._l(_vm.links, function (link) {
                return _c(
                  "div",
                  {
                    key: link.id,
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      flex: "1 0px !important",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: `/eventinfo/${link[0]}` },
                          target: "_blank",
                        },
                      },
                      [
                        _c(
                          "pui-button",
                          {
                            staticStyle: {
                              display: "inline-flex",
                              "margin-bottom": "0.25em",
                            },
                            attrs: { state: "secondary" },
                          },
                          [_c("span", [_vm._v(_vm._s(link[1]))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }